import { Button } from "@shapr3d/frontend-lib";
import { useParams } from "react-router-dom";

import shareViewLinkIllustration from "../../assets/images/shareViewLinkIllustration.webp";
import { CollaborationPromoURL } from "../../config";
import { useTracker } from "../../hooks/useTracker";

import style from "./CollaborationPromo.module.css";

export const CollaborationPromo = () => {
  const tracker = useTracker();
  const { teamID } = useParams();

  return (
    <div className={style.pageContainer}>
      <div className={style.promoContainer}>
        <img
          src={shareViewLinkIllustration}
          alt="Share view link illustration"
          className={style.illustration}
        />
        <div className={style.title}>Get Feedback & Collaborate</div>
        <div className={style.subtitle}>
          Gather feedback from stakeholders while maintaining full control over who can view your
          model.
        </div>
        <Button
          variant="grayscale"
          onClick={() => {
            tracker.trackGoToCollaborationPromo({
              activeTeamId: teamID,
              location: "review_links",
            });
            window.open(CollaborationPromoURL);
          }}
        >
          Learn More How
        </Button>
      </div>
    </div>
  );
};
